// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { productActionsStyle, ProductActionsStyle } from "@sc/App/Components/Product/ProductActions";
import { xScreen } from "@sc/XDL/Utilities";
import { css } from "styled-components";

export const productActionsExtensions: ProductActionsStyle = {
    addToCartContainer: {
        css: css`
            display: flex;
            align-items: center;
            width: 100%;
            flex-wrap: wrap;
            gap: 8px;
        `,
    },
    qtyWrapper: {
        css: css`
            max-width: 100px;
        `,
    },

    productAddToCartButtonStyles: {
        mergeCss: true,
        sizeVariant: "medium",
        css: css`
            &:not(.button-wrapper-icon-only) {
                width: 100%;
                min-width: unset;
            }
        `,
    },
    addToCartButtonWrapper: {
        css: css`
            && {
                flex-grow: 1;
                width: auto;
            }
        `,
    },
    productQuantityOrderedStyles: {
        wrapper: {
            css: css`
                ${xScreen("lte", "md")} {
                    min-width: inherit;
                }
            `,
        },
    },
    productUomWrapper: {
        css: css`
            &:empty {
                display: none;
            }
        `,
    },
    productUnitOfMeasureSelectStyles: {
        sizeVariant: "small",
    },
};

productActionsStyle.addToCartContainer = productActionsExtensions.addToCartContainer;
productActionsStyle.qtyWrapper = productActionsExtensions.qtyWrapper;
productActionsStyle.productAddToCartButtonStyles = productActionsExtensions.productAddToCartButtonStyles;
productActionsStyle.productQuantityOrderedStyles = productActionsExtensions.productQuantityOrderedStyles;
productActionsStyle.addToCartButtonWrapper = productActionsExtensions.addToCartButtonWrapper;
productActionsStyle.productUomWrapper = productActionsExtensions.productUomWrapper;
productActionsStyle.productUnitOfMeasureSelectStyles = productActionsExtensions.productUnitOfMeasureSelectStyles;
